import { render, staticRenderFns } from "./SelectorBlock.vue?vue&type=template&id=1a569e37"
import script from "./SelectorBlock.vue?vue&type=script&lang=js"
export * from "./SelectorBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports